import { loggerCan } from '@/data/utils/loggerUtil';
import { ContentType, HttpClient, RequestParams } from './http-client';
import { logger } from '@/logging/logger';

export class ExtendedZone<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;
	traceDetails: string | undefined;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
		this.traceDetails = process.env.TRACE_DETAILS?.trim();
	}

	/**
	 * @tags transactions
	 * @name validateExtendedZone
	 * @summary Validate extended zone
	 * @request GET:/store/{storeId}/extended-zone/{zipcode}
	 * @secure
	 * @description Validate if the zipcode is extended zone
	 * And also can check by order to know if will have shipping by extended zone 
	 */

	validateExtendedZone = (
		storeId: string,
		zipCode: string, 
		query?: {
			responseFormat?: 'xml' | 'json';
			orderId?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;
		//Trace
		if (
			loggerCan('trace') &&
			(!this.traceDetails || this.traceDetails.includes('validateExtendedZone'))
		) {
			const paramsLogger = logger.child({
				params,
				query: query ?? {},
				body: null ?? {},
				methodName: 'validateExtendedZone',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}
		//Request
		return this.http.request<any, void>({
			path: `/store/${storeId}/extended-zone/${zipCode}`,
			method: 'GET',
			query: query,
			secure: true,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};
}
